import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LogoutIcon from '@mui/icons-material/Logout';
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import "./Header.css";
import { useSnackbar } from "notistack";
// import { useNavigate } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";

import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { display } from "@mui/system";



const Header = ({ children, hasHiddenAuthButtons, onSearch, searchValue="" }) => {
  const { enqueueSnackbar } = useSnackbar();
  // const navigate = useNavigate();
  const history = useHistory();

  const username = localStorage.getItem("username");
  const isLoggedIn = Boolean(localStorage.getItem('token'))

  const handleLogout = (e) => {
    // history.push("/"); // Navigate first
    history.push("/products");
    localStorage.clear()
    enqueueSnackbar("Logged Out successfully", {variant:"success"});
    // setTimeout(() => 
    // window.location.reload(),    
    // 10); // Clear storage after
  };

    return (
      <Box className="header">
        <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
        </Box> 
        <Box>
            
            <TextField    
            className="search-desktop"   
            value={searchValue} 
            onChange={onSearch}  
            size="small"
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search color="primary" />
                </InputAdornment>
              ),
            }}
            placeholder="Search for items/categories"
            name="search"
          />
          </Box>
        {hasHiddenAuthButtons ? (
        //   <Button
        //   className="explore-button" onClick={() => navigate("/")}
        //   startIcon={<ArrowBackIcon />}
        //   variant="text"
        // >
        //   Back to explore
        // </Button>
            <Button
        className="explore-button" onClick={() => history.push("/")}
        startIcon={<ArrowBackIcon />}
        variant="text"
      >
        Back to explore
      </Button>
        ):isLoggedIn ?(
          <Box sx={{display:"flex", alignItems:"center", gap:"10px"}}> 
            
            <Typography>
            {username}
            </Typography>
            <img src="avatar.png" alt={username} className="avatar" />
         {/* <span>{username}<img src="avatar.png" alt={username} /></span>      */}
          <Button className="button" varient="contained" 
          onClick={handleLogout} 
          
          
          endIcon={<LogoutIcon />}>
            Logout
          </Button>
        </Box>
        ) :(  
          <>
        

        <Box>
         
          <Button className="button" onClick={()=> history.push("/login")}>
            Login
          </Button>
          <Button className="button" onClick={()=> history.push("/register")}>
            Register
          </Button>
        </Box>
        </>
        
        )}  
      </Box>
    );

  };

export default Header;
